import { Box, Divider } from '@mui/material'
import React from 'react'
import { FundTrackRecord } from '../../../../models/Fund';
import TrackRecordsListItem from './TrackRecordsListItem';

export interface ITrackRecordsListProps {
    trackRecords: FundTrackRecord[];
}

const TrackRecordsList: React.FC<ITrackRecordsListProps> = ({ trackRecords }) => {
    return <Box display={"flex"} gap={"32px"}>
        {trackRecords.map((t, i) => (<>
            <TrackRecordsListItem trackRecord={t} key={`trackrecord-${t.id}`} />
            {(i+1) !== trackRecords.length && <Divider orientation="vertical" flexItem />}
        </>))}
    </Box>
}

export default TrackRecordsList